import WalletInfo from './WalletInfo';

export default WalletInfo;
